// Shared, browser-safe CEO Practitioner Network promotional copy.
export const NETWORK_URL = "https://ceopractitionernetwork.com";
export const NETWORK_HEADING = "CEO Practitioner Network";
export const NETWORK_TAGLINE = "The work is specialized. Your professional network should be too.";
export const NETWORK_SUMMARY =
  "A professional, practitioner-led network for law enforcement Community Engagement officers, civilian staff, and supervisors. Learn practitioner to practitioner, build skills through applied training, draw on shared resources, and help advance Community Engagement as a professional discipline.";
export const NETWORK_FOUNDING =
  "Free Founding Membership Available through April 15, 2027, subject to manual professional approval.";
export const NETWORK_SEPARATE =
  "The Community Engagement Impact Conference, March 30–31, 2027, and paid courses are registered separately.";
export const NETWORK_CTA = "Explore the CEO Practitioner Network";
